import startsWith from 'lodash/startsWith';

import { TeamNanoID } from '../../../../teams/teamsTypes';
import { CompactCompanyLibraryMenuItems } from './CompactCompanyLibraryMenu.types';
import { PrimaryNavTabTooltipItem } from '../../../../../app/components/menus/PrimaryNav/helpers/PrimaryNavTooltipMenuTab/PrimaryNavTooltipMenuTab.types';

import { CommonPermissions } from '../../../commonConstants';
import { TeamPath } from '../../../../teams/TeamPath';

import {
  lifestylesKeys,
  materialsKeys,
  productsKeys,
  twinsKeys
} from '../../../../../locales/keys';

export const selfCompanyLibraryMenuLinks: PrimaryNavTabTooltipItem[] = [
  {
    activeTest: (pathname: string) =>
      startsWith(pathname, TeamPath.currentCompanyLibraryProducts()),
    name: CompactCompanyLibraryMenuItems.PRODUCTS,
    href: TeamPath.currentCompanyLibraryProducts(),
    i18nText: productsKeys.plural,
    permissions: [
      CommonPermissions.READ_COMPACT_SELF_COMPANY_LIBRARY_MENU_PRODUCTS_LINK
    ]
  },
  {
    activeTest: (pathname: string) =>
      startsWith(pathname, TeamPath.currentCompanyLibraryLifestyles()),
    name: CompactCompanyLibraryMenuItems.LIFESTYLES,
    href: TeamPath.currentCompanyLibraryLifestyles(),
    i18nText: lifestylesKeys.plural,
    permissions: [
      CommonPermissions.READ_COMPACT_SELF_COMPANY_LIBRARY_MENU_LIFESTYLES_LINK
    ]
  },
  {
    activeTest: (pathname: string) =>
      startsWith(pathname, TeamPath.currentCompanyLibraryMaterials()),
    name: CompactCompanyLibraryMenuItems.MATERIALS,
    href: TeamPath.currentCompanyLibraryMaterials(),
    i18nText: materialsKeys.plural,
    permissions: [
      CommonPermissions.READ_COMPACT_SELF_COMPANY_LIBRARY_MENU_MATERIALS_LINK
    ]
  }
];

export const selfCompanyNewLibraryMenuLinks: PrimaryNavTabTooltipItem[] = [
  {
    activeTest: (pathname: string) =>
      startsWith(pathname, TeamPath.currentCompanyNewLibraryProductsPure()),
    name: CompactCompanyLibraryMenuItems.NEW_PRODUCTS,
    href: TeamPath.currentCompanyNewLibraryProducts(),
    i18nText: productsKeys.plural,
    permissions: [
      CommonPermissions.READ_COMPACT_SELF_COMPANY_NEW_LIBRARY_MENU_PRODUCTS_LINK
    ]
  },
  {
    activeTest: (pathname: string) =>
      startsWith(pathname, TeamPath.currentCompanyNewLibraryLifestylesPure()),
    name: CompactCompanyLibraryMenuItems.NEW_LIFESTYLES,
    href: TeamPath.currentCompanyNewLibraryLifestyles(),
    i18nText: lifestylesKeys.plural,
    permissions: [
      CommonPermissions.READ_COMPACT_SELF_COMPANY_NEW_LIBRARY_MENU_LIFESTYLES_LINK
    ]
  },
  {
    activeTest: (pathname: string) =>
      startsWith(pathname, TeamPath.currentCompanyNewLibraryMaterialsPure()),
    name: CompactCompanyLibraryMenuItems.NEW_MATERIALS,
    href: TeamPath.currentCompanyNewLibraryMaterials(),
    i18nText: materialsKeys.plural,
    permissions: [
      CommonPermissions.READ_COMPACT_SELF_COMPANY_NEW_LIBRARY_MENU_MATERIALS_LINK
    ]
  },
  {
    activeTest: (pathname: string) =>
      startsWith(pathname, TeamPath.currentCompanyNewLibraryTwinsPure()),
    name: CompactCompanyLibraryMenuItems.NEW_TWINS,
    href: TeamPath.currentCompanyNewLibraryTwins(),
    i18nText: twinsKeys.plural,
    permissions: [
      CommonPermissions.READ_COMPACT_SELF_COMPANY_NEW_LIBRARY_MENU_TWINS_LINK
    ]
  }
];

export const companyLibraryMenuLinks = (
  companyNanoId: TeamNanoID
): PrimaryNavTabTooltipItem[] => [
  {
    activeTest: (pathname: string) =>
      startsWith(pathname, TeamPath.companyLibraryProducts(companyNanoId)),
    name: CompactCompanyLibraryMenuItems.PRODUCTS,
    href: TeamPath.companyLibraryProducts(companyNanoId),
    i18nText: productsKeys.plural,
    permissions: [
      CommonPermissions.READ_COMPACT_SELF_COMPANY_LIBRARY_MENU_PRODUCTS_LINK
    ]
  },
  {
    activeTest: (pathname: string) =>
      startsWith(pathname, TeamPath.companyLibraryLifestyles(companyNanoId)),
    name: CompactCompanyLibraryMenuItems.LIFESTYLES,
    href: TeamPath.companyLibraryLifestyles(companyNanoId),
    i18nText: lifestylesKeys.plural,
    permissions: [
      CommonPermissions.READ_COMPACT_SELF_COMPANY_LIBRARY_MENU_LIFESTYLES_LINK
    ]
  },
  {
    activeTest: (pathname: string) =>
      startsWith(pathname, TeamPath.companyLibraryMaterials(companyNanoId)),
    name: CompactCompanyLibraryMenuItems.MATERIALS,
    href: TeamPath.companyLibraryMaterials(companyNanoId),
    i18nText: materialsKeys.plural,
    permissions: [
      CommonPermissions.READ_COMPACT_SELF_COMPANY_LIBRARY_MENU_MATERIALS_LINK
    ]
  }
];

export const companyNewLibraryMenuLinks = (
  companyNanoId: TeamNanoID,
  isSelf: boolean
): PrimaryNavTabTooltipItem[] => [
  {
    activeTest: (pathname: string) =>
      startsWith(
        pathname,
        TeamPath.companyNewLibraryProductsPure(companyNanoId)
      ),
    name: CompactCompanyLibraryMenuItems.NEW_PRODUCTS,
    href: TeamPath.companyNewLibraryProducts(companyNanoId),
    i18nText: productsKeys.plural,
    permissions: [
      isSelf
        ? CommonPermissions.READ_COMPACT_SELF_COMPANY_NEW_LIBRARY_MENU_PRODUCTS_LINK
        : CommonPermissions.READ_COMPACT_OTHER_COMPANY_NEW_LIBRARY_MENU_PRODUCTS_LINK
    ]
  },
  {
    activeTest: (pathname: string) =>
      startsWith(
        pathname,
        TeamPath.companyNewLibraryLifestylesPure(companyNanoId)
      ),
    name: CompactCompanyLibraryMenuItems.NEW_LIFESTYLES,
    href: TeamPath.companyNewLibraryLifestyles(companyNanoId),
    i18nText: lifestylesKeys.plural,
    permissions: [
      isSelf
        ? CommonPermissions.READ_COMPACT_SELF_COMPANY_NEW_LIBRARY_MENU_LIFESTYLES_LINK
        : CommonPermissions.READ_COMPACT_OTHER_COMPANY_NEW_LIBRARY_MENU_LIFESTYLES_LINK
    ]
  },
  {
    activeTest: (pathname: string) =>
      startsWith(
        pathname,
        TeamPath.companyNewLibraryMaterialsPure(companyNanoId)
      ),
    name: CompactCompanyLibraryMenuItems.NEW_MATERIALS,
    href: TeamPath.companyNewLibraryMaterials(companyNanoId),
    i18nText: materialsKeys.plural,
    permissions: [
      isSelf
        ? CommonPermissions.READ_COMPACT_SELF_COMPANY_NEW_LIBRARY_MENU_MATERIALS_LINK
        : CommonPermissions.READ_COMPACT_OTHER_COMPANY_NEW_LIBRARY_MENU_MATERIALS_LINK
    ]
  },
  {
    activeTest: (pathname: string) =>
      startsWith(pathname, TeamPath.companyNewLibraryTwinsPure(companyNanoId)),
    name: CompactCompanyLibraryMenuItems.NEW_TWINS,
    href: TeamPath.companyNewLibraryTwins(companyNanoId),
    i18nText: twinsKeys.plural,
    permissions: [
      isSelf
        ? CommonPermissions.READ_COMPACT_SELF_COMPANY_NEW_LIBRARY_MENU_TWINS_LINK
        : CommonPermissions.READ_COMPACT_OTHER_COMPANY_NEW_LIBRARY_MENU_TWINS_LINK
    ]
  }
];
